<div class="order-info" data-ph-mask [class.disabled]="fulfillService.orderHasPendingUpdates$ | async">
  <div class="order-info__tablet-toggle" (click)="toggleDetails()">
    <pdq-icon icon="side_right_arrow"></pdq-icon> {{ displayStat === 'none' ? 'Hide' : 'View' }} shipping details
  </div>
  <ul #info>
    @if (isShowSuggestedAddressBanner) {
      <div class="order-info__details-section">
        <pdq-banner
          variant="regular"
          class="banner"
          bannerTitle="Shipping address slighlty modified"
          [content]="modifiedAddressBannerMessage">
        </pdq-banner>
      </div>
    }

    <!-- SHIP TO -->
    <div class="order-info__details-section">
      @if (hasShipTo) {
        <div class="order-info__details-col">
          <li class="title">Ship to</li>
          @if (shipTo.firstName) {
            <li class="field">{{ order.shippingFirstName }}</li>
          }
          @if (shipTo.lastName) {
            <li class="field">{{ order.shippingLastName }}</li>
          }
          @if (shipTo.company) {
            <li class="field">{{ order.shippingAddress?.company }}</li>
          }
          @if (shipTo.phone) {
            <li class="field">{{ order.shippingPhone }}</li>
          }
          <!-- CUSTOMER GROUPS -->
          @if (hasCustomerGroups) {
            <li class="title">Customer profile</li>
            <li class="tags">
              <span>
                <app-orders-count-chip
                  class="assign-sidebar__orders-count-chip"
                  [size]="1"
                  [row]="order"></app-orders-count-chip>
              </span>
              @if (customerGroups?.length > 0) {
                <div class="order-info__customer-groups">
                  @for (group of customerGroups; track group) {
                    <pdq-tag mode="rect" [value]="group"></pdq-tag>
                  }
                </div>
              }
              @if (order.customer?.note) {
                <div class="order-info__customer-note">
                  <div>Note <pdq-icon icon="note_by_the_customer" class="icon"></pdq-icon></div>
                  <div style="word-break: break-all">{{ order.customer.note }}</div>
                </div>
              }
            </li>
          }
          <!-- PRINT -->
          <li class="print-btn">
            <pdq-dropdown
              icon="print"
              type="actionList"
              placeholder="Print"
              [options]="printOptions"
              [sections]="printSections"
              (onChange)="printOrder.emit($event)"></pdq-dropdown>
          </li>
        </div>
      }

      <!-- SHIPPING ADDRESS -->
      @if (order?.shippingAddress) {
        <div class="order-info__details-col">
          <li class="title">Shipping address</li>
          @if (order.shippingAddress.address1) {
            <li class="field">{{ order.shippingAddress.address1 }}</li>
          }
          @if (order.shippingAddress.address2) {
            <li class="field">{{ order.shippingAddress.address2 }}</li>
          }
          @if (order.shippingAddress.city) {
            <li class="field">{{ order.shippingAddress.city }}</li>
          }
          @if (order.shippingAddress.province) {
            <li class="field">{{ order.shippingAddress.province }}</li>
          }
          @if (order.shippingAddress.country) {
            <li class="field">{{ order.shippingAddress.country }}</li>
          }
          @if (order.shippingAddress.zip) {
            <li class="field">{{ order.shippingAddress.zip }}</li>
          }
        </div>
      }
    </div>

    <!-- NOTES -->
    @if (order['note']) {
      <div class="order-info__note-section">
        <div>
          <span class="title">Order note</span>
          <pdq-icon icon="note_by_the_customer" class="icon"></pdq-icon>
        </div>
        <notes-card [note]="order['note']"></notes-card>
      </div>
    }

    <!-- NOTE ATTRIBUTES -->
    @if (order.noteAttributes) {
      <app-note-attributes [activeOrder]="order"></app-note-attributes>
    }

    <!-- TEAM NOTES -->
    @if (teamNotes?.length) {
      <div class="order-info__team-notes-section">
        <span class="title">Team notes</span>
        @for (teamN of teamNotes; track teamN; let i = $index) {
          <div>
            @if (i < maxTeamNotesDisplay) {
              <team-notes-card [teamNote]="teamN" [allowActions]="false"> </team-notes-card>
            }
          </div>
        }
        @if (teamNotes.length > 1) {
          <a (click)="displayAllTeamNotes()">
            {{ showAllTeamNotes ? 'Show less' : 'Show more (' + (teamNotes.length - 1) + ') notes' }}</a
          >
        }
      </div>
    }
    <!-- DELIVERY SERVICE -->
    <div class="section-content">
      <order-info-tracking-number [isEditingEnabled]="isTrackingNumberEditingEnabled"></order-info-tracking-number>
    </div>

    <!-- TAGS -->
    <div class="order-info__tags-section">
      <div class="title" [style.width]="'100%'">Order and product tags</div>
      <div class="tags-container">
        @for (tag of tags; track tag) {
          <pdq-tag [value]="tag" maxWidth="150" class="tag"></pdq-tag>
        }
      </div>
    </div>
    <!-- SHIPMENT EXTRAS -->
    <app-shipment-extras [activeOrder]="order" [isEditable]="false" parentComponent="fulfill-side-bar">
    </app-shipment-extras>
    <!-- ORDER HISTORY -->
    <div class="history-wrapper" [ngClass]="{ 'is-partial': isPartialHistory }">
      <app-order-history-component [activeOrder]="order"></app-order-history-component>
    </div>
    @if (isPartialHistory) {
      <div class="history-link" (click)="isPartialHistory = false">Show full order history</div>
    }
  </ul>
</div>
